export default __webpack_public_path__ + "static/media/applications-image-04.f914c447.jpg";